import { usePromptToolboxContext } from "@Context/prompt-toolbox/PromptToolboxContext";
import { useUtilityContext } from "@Context/prompt-toolbox/UtilityContext";

const DeletePrompt = () => {
  const { setModal } = useUtilityContext();
  const { deletePrompt } = usePromptToolboxContext();

  const handleDelete = async () => {
    setModal("deletePrompt", false);
    await deletePrompt();
  };

  return (
    <div>
      <span className="flex flex-col gap-y-10">
        <label>This will delete the whole prompt including its versions.</label>
        <span className="flex flex-row items-center justify-end gap-x-2">
          <button data-testid="delete-prompt-modal-button"
            onClick={handleDelete}
            className="rounded-md bg-brandRed-300 px-4 py-2 text-white"
          >
            Delete
          </button> 
          <button data-testid="delete-prompt-modal-cancel-button"
            onClick={() => setModal("deletePrompt", false)}
            className="rounded-md border border-gray-400 bg-white px-4 py-2"
          >
            Cancel
          </button>
        </span>
      </span>
    </div>
  );
};

export default DeletePrompt;
